import React from "react";

export default function Settings() {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "calc(100vh - 64px)",
                padding: "20px",
                textAlign: "center"
            }}
        >
            <div>
                <h1 style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "10px" }}>
                    Settings
                </h1>
                <p style={{ color: "#555", fontSize: "16px" }}>
                    The settings feature is not implemented yet. Please check back later.
                </p>
            </div>
        </div>
    );
}
